var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:['region-delivery-label', {'multi-regions': _vm.multiRegionMode}]},[_vm._v("\n  Доставка "),_c('strong',{on:{"click":_vm.showRegionSelect}},[_vm._v(_vm._s(_vm.curRegionNamePadeg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }